import {
    WORKFLOW_STATUS_CANCELLED,
    WORKFLOW_STATUS_CLIENT_REVIEW,
    WORKFLOW_STATUS_COMINGDUE_PROJECT,
    WORKFLOW_STATUS_COMPLETED,
    WORKFLOW_STATUS_COMPLETED_PROJECT,
    WORKFLOW_STATUS_EDITING,
    WORKFLOW_STATUS_FINANCIAL_APPROVAL,
    WORKFLOW_STATUS_INPROGRESS_PROJECT,
    WORKFLOW_STATUS_PASTDUE_PROJECT,
    WORKFLOW_STATUS_QUOTING,
    WORKFLOW_STATUS_REVIEW,
    WORKFLOW_STATUS_REVISION,
    WORKFLOW_STATUS_SIGN_OFF,
    WORKFLOW_STATUS_TRANSLATION,
} from './workflowStatus'
import { StatusDetails } from '../../../../httpClient/interfaces/StatusDetails'

const statusTransform = (name: string): StatusDetails => {
    switch (name) {
        case WORKFLOW_STATUS_QUOTING:
            return { name: 'memsource.status.quoting', color: 'quoting' }
        case WORKFLOW_STATUS_TRANSLATION:
            return { name: 'memsource.status.translation', color: 'translation' }
        case WORKFLOW_STATUS_CLIENT_REVIEW:
            return { name: 'memsource.status.client_review', color: 'clientReviewLqa' }
        case WORKFLOW_STATUS_REVISION:
            return { name: 'memsource.status.revision', color: 'revisionLqa' }
        case WORKFLOW_STATUS_SIGN_OFF:
            return { name: 'memsource.status.sign_off', color: 'signOff' }
        case WORKFLOW_STATUS_CANCELLED:
            return { name: 'memsource.status.cancelled', color: 'cancelled' }
        case WORKFLOW_STATUS_COMPLETED:
        case WORKFLOW_STATUS_COMPLETED_PROJECT:
            return { name: 'memsource.status.completed', color: 'completed' }
        case WORKFLOW_STATUS_FINANCIAL_APPROVAL:
            return { name: 'memsource.status.financial_approval', color: 'financialApproval' }
        case WORKFLOW_STATUS_EDITING:
            return { name: 'memsource.status.editing', color: 'editing' }
        case WORKFLOW_STATUS_REVIEW:
            return { name: 'memsource.status.review', color: 'review' }
        case WORKFLOW_STATUS_COMINGDUE_PROJECT:
            return { name: 'memsource.status.coming_due', color: 'comingDue' }
        case WORKFLOW_STATUS_INPROGRESS_PROJECT:
            return { name: 'memsource.status.in_progress', color: 'inProgress' }
        case WORKFLOW_STATUS_PASTDUE_PROJECT:
            return { name: 'memsource.status.past_due', color: 'pastDue' }
        default:
            return { name: 'xtrf.page_project_list.status.no_status', color: 'noStatus' }
    }
}

export default statusTransform
